/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarServer = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var CalendarServer = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        CalendarService: function () {
            return function (headers) {
                var service = {
                    listSessions: function (listSessionsRequest) {
                        return httpClient.invoke('POST', '/v1/calendar/listSessions', listSessionsRequest, headers);
                    },
                    listSlots: function (listSlotsRequest) { return httpClient.invoke('POST', '/v1/calendar/listSlots', listSlotsRequest, headers); },
                };
                service.listSessions.__http_method = 'POST';
                service.listSessions.__http_url = '/v1/calendar/listSessions';
                service.listSlots.__http_method = 'POST';
                service.listSlots.__http_url = '/v1/calendar/listSlots';
                return service;
            };
        },
    };
};
exports.CalendarServer = CalendarServer;
exports.CalendarServer.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map